import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { Sector } from '@/domain/impact/impact.entity';
import { RootState } from '@/domain/store';

export const selectExternalInvitations = (state: RootState) => {
  return state.externalInvitation.items;
};

export const selectExternalInvitationsForScope =
  (scope: Scope) => (state: RootState) => {
    const items = state.externalInvitation.items.filter(
      (x) => x.scope === scope,
    );
    return items;
  };

export const selectExternalInvitationsForScopes =
  (scopes: Scope[]) => (state: RootState) => {
    const items = state.externalInvitation.items.filter((x) =>
      scopes.includes(x.scope),
    );
    return items;
  };

export const selectExternalInvitationPublic = (state: RootState) => {
  const index = state.externalInvitation.items.findIndex(
    (x) => x.scope === 'PUBLIC',
  );
  if (index !== -1) {
    return state.externalInvitation.items[index];
  }
};

export const selectExternalInvitationsForSector =
  (sector: Sector) => (state: RootState) => {
    const items = state.externalInvitation.items.filter(
      (x) => x.sector === sector,
    );
    return items;
  };

export const selectValidatedExternalInvitationsForSector =
  (sector: Sector) => (state: RootState) => {
    const items = state.externalInvitation.items.filter(
      (x) => x.sector === sector && x.isValidated === true,
    );
    return items;
  };

export const selectValidatedExternalInvitations = (state: RootState) => {
  const items = state.externalInvitation.items.filter(
    (x) => x.isValidated === true,
  );
  return items;
};

export const selectExternalInvitationsCountForSector =
  (sector: Sector) => (state: RootState) => {
    const items = selectExternalInvitationsForSector(sector)(state);
    return items.length;
  };

export const selectExternalInvitationsCountForAllSector =
  () =>
  (state: RootState): { [key in Sector]: number } => {
    return {
      '': 0,
      ANY: selectExternalInvitationsCountForSector('ANY')(state),
      SITE: selectExternalInvitationsCountForSector('SITE')(state),
      TEAM: selectExternalInvitationsCountForSector('TEAM')(state),
      ARTISTS: selectExternalInvitationsCountForSector('ARTISTS')(state),
      PUBLIC: selectExternalInvitationsCountForSector('PUBLIC')(state),
    };
  };

export const selectExternalInvitationsCountForScope =
  (scope: Scope) => (state: RootState) => {
    const items = selectExternalInvitationsForScope(scope)(state);
    return items.length;
  };
